import { render } from "./colour-swatches.vue?vue&type=template&id=38601748"
import script from "./colour-swatches.vue?vue&type=script&lang=js"
export * from "./colour-swatches.vue?vue&type=script&lang=js"

import "./colour-swatches.vue?vue&type=style&index=0&id=38601748&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__